<template>
  <div class="container" v-if="item">
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-6">
        <h1>Settings</h1>
        <hr />
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col">
            <h5>Dark Mode</h5>
          </div>
          <div class="col text-right">
            <ez-switch
              v-model="item.settings.darkMode"
              :error="errors['active']"
            ></ez-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import EzSwitch from "../shared/_VueEzSwitch.vue";
import EzSelect2 from "../shared/_VueEzSelect2.vue";

export default {
  name: "user-edit",
  components: {
    EzSwitch,
    EzSelect2
  },
  data() {
    return {
      errors: {}
    };
  },
  watch: {
    "item.settings.darkMode": "patchData"
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin"
    }),
    ...mapState({
      item: state => state.session.user
    })
  },
  methods: {
    ...mapActions({
      usersMyProfile: "users/myProfile",
      updateSettings: "updateSettings"
    }),
    async patchData() {
      try {
        await this.updateSettings(this.item.settings);
      } catch (err) {
        console.error(err);
        this.errors = Object.assign({}, this.errors, err.response.data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h5 {
  margin-top: 0.3em;
}
</style>
